/** Production first: motion-centric satisfying films default to 60 fps. */
export const PRODUCTION_FPS = 60;
/** Preserve legacy frame-authored comparisons until individually retimed and reviewed. */
export const LEGACY_PREVIEW_FPS = 30;
export const framesForSeconds = (seconds: number, fps: number = PRODUCTION_FPS) =>
  Math.round(seconds * fps);
